import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
export function PrV2StickyGroupGuide(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <aside className="custom-scrollbar min-w-0 self-start @min-[64rem]/pr-diff:sticky @min-[64rem]/pr-diff:top-12 @min-[64rem]/pr-diff:z-[25] @min-[64rem]/pr-diff:max-h-[calc(100vh-var(--header-height)-3rem)] @min-[64rem]/pr-diff:overflow-x-hidden @min-[64rem]/pr-diff:overflow-y-auto">{children}</aside>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}